import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { MarketdateBoothComponent } from './marketdate-booth.component';
import { MarketdateBoothDetailComponent } from './marketdate-booth-detail.component';
import { MarketdateBoothPopupComponent } from './marketdate-booth-dialog.component';
import { MarketdateBoothDeletePopupComponent } from './marketdate-booth-delete-dialog.component';

import { Principal } from '../../shared';

export const marketdateBoothRoute: Routes = [
  {
    path: 'marketdate-booth',
    component: MarketdateBoothComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'marketdate-booth/:id',
    component: MarketdateBoothDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const marketdateBoothPopupRoute: Routes = [
  {
    path: 'marketdate-booth-new',
    component: MarketdateBoothPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-booth/:id/edit',
    component: MarketdateBoothPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-booth/:id/delete',
    component: MarketdateBoothDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateBooth.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-booth/marketdate-booth.route.ts